import { ChatResponse, MessagesResponse } from '../models/ChatDto'
import { DonateItem } from '../models/DonateItem'
import { Prize } from '../models/Prize'
import { UserProfile } from "../models/UserProfile"
import { AchievementResponse } from '../models/response/AchievementResponse'
import { CaseInfo } from '../models/response/CaseInfo'
import { api, BASE_URL } from './api'
import { createAuthenticatedEventSource } from './authenticatedEventSource'

export default class UserService {

    static async convertDpTo(amount: number, type: string): Promise<void> {
        await api.post('/user/donate/convert', { amount, type })
    }

    static async getUserProfile(): Promise<UserProfile> {
        const response = await api.get('/user/profile', {})
        return response.data as UserProfile
    }

    static async getCaseInfo(type: string): Promise<CaseInfo> {
        const response = await api.get(`/user/donate/case/info?type=${type}`)
        return response.data as CaseInfo
    }

    static async subscribe(name: string, days: number): Promise<void> {
        await api.post('user/donate/subscribe', { name, days })
    }

    static async buyCase(type: string): Promise<void> {
        await api.post('user/donate/case/money/buy', { type })
    }

    static async openCase(type: string): Promise<Prize> {
        const response = await api.post('user/donate/case/open', { type })
        return response.data as Prize
    }

    static async buyBattlepassBundle(bundleType: string): Promise<void> {
        await api.post('/user/donate/battlepass/bundle/buy', { bundleType })
    }

    static async buyBattlepassCustom(bundleType: string, level: number): Promise<void> {
        await api.post('/user/donate/battlepass/custom/buy', { bundleType, level })
    }

    static async getAchievements(): Promise<AchievementResponse> {
        const response = await api.get('/user/achievements', {})
        return response.data as AchievementResponse
    }

    static async getChats(): Promise<ChatResponse> {
        const response = await api.get(`/user/chat/all`)
        return response.data as ChatResponse
    }

    static async getMessages(chatId: number): Promise<MessagesResponse> {
        const response = await api.get(`/user/chat/messages?chatId=${chatId}`)
        return response.data as MessagesResponse
    }

    static async sendMessage(chatId: number, content: string): Promise<string> {
        const response = await api.post(`/user/chat/message/send`, { chatId, content })
        return response.data as string
    }

    static async markMessagesAsRead(chatId: number, messagesId: string[]): Promise<boolean> {
        const response = await api.post(`/user/chat/message/read`, { chatId, messagesId })
        return response.data as boolean
    }

    static async openLobby(): Promise<void> {
        await api.post('/user/lobby/open', {})
    }

    static getMessagesSSE(token: string): EventSource {
        return createAuthenticatedEventSource(`${BASE_URL}/user/chat/stream?token=${token}`)
    }

    static getChatsSSE(token: string): EventSource {
        return createAuthenticatedEventSource(`${BASE_URL}/user/chats/stream?token=${token}`)
    }

    static getOnlineSSE(token: string): EventSource {
        return createAuthenticatedEventSource(`${BASE_URL}/player/online/stream?token=${token}`)
    }

    static async fetchInventory(): Promise<DonateItem[]> {
        const response = await api.get(`/user/donate/inventory`)
        return response.data as DonateItem[]
    }

    static async discardPrize(caseId: string): Promise<void> {
        await api.post(`/user/donate/case/prize/discard`, { caseId })
    }

    static async applyPrize(caseId: string): Promise<void> {
        await api.post(`/user/donate/case/prize/apply`, { caseId })
    }

    static async leaveFreeroam(): Promise<void> {
        await api.post(`/freeroom/leave`, {})
    }
} 